import { Card as CardAntd, Typography } from 'antd';
import styled from 'styled-components';

export const Card = styled(CardAntd)`
  background: #f5f5f6;
  border-left: 5px solid #e7e7e7;
  margin-top: 24px;
  margin-bottom: 24px;
  width: 100%;

  .ant-card-body {
    padding: 10px !important;
  }
`;

export const Text = styled(Typography.Paragraph)`
  margin: 0 !important;
`;

export const Title = styled.span`
  font-weight: bold;
  color: #d42929;
`;
